import React, { Component} from 'react'
import { connect } from 'react-redux'
import {addGoogleSignin,removeGoogleSignin} from '../../actions/user'
import {hideModal} from '../../actions/modals'
import {showNotification} from '../../actions/notifications'
import VerifyWithPasswordForm from '../../components/forms/account/VerifyWithPasswordForm'
import Button from '../../components/uiKit/Button'
import FeatureModalSelectControl from '../../components/featureModals/FeatureModalSelectControl'
import errorMessages from '../../errorMessages.js'


class AccountAuthenticationContainer extends Component {

	constructor(){
		super()
		this.addGoogle=this.addGoogle.bind(this)
		this.removeGoogle=this.removeGoogle.bind(this) 

		this.state = {
			submitLoading:false,
			errorMessage:null,
			logOut:false
		
		}
	}

	addGoogle(formData){
		this.setState({submitLoading:true,errorMessage:null})
		const requestData={
			idToken:this.props.googleUser.tokenId,
			password:formData.currentPassword
		}
		this.props.addGoogleSignin(this.props.user.id,requestData).then((response) => {
			this.props.hideModal()
		 	this.props.showNotification('Google Sign in access to your account','Added','default')


		})
			.catch(error => {
				this.props.hideModal()
				let errorMessage='Something went wrong. Could not add Google Sign in access.'
				if(errorMessages.accountErrors.addGoogleSignin[error.response.status]){
			 		errorMessage=`${errorMessages.accountErrors.addGoogleSignin[error.response.status]}`
				}
				this.props.showNotification(errorMessage,'Error:','destroy')

			})
	}


	removeGoogle(formData){
		this.setState({submitLoading:true,errorMessage:null})
		const requestData={
			password:formData.currentPassword
		}
		this.props.removeGoogleSignin(this.props.user.id,requestData,this.state.logOut).then((response) => {
			this.props.hideModal()
			this.props.showNotification('','Succesfully removed Google account','default')		
		})
			.catch(error => {
				// this.props.hideModal()
				let errorMessage='Something went wrong'
				if(errorMessages.accountErrors.addGoogleSignin[error.response.status]){
			 		errorMessage=`${errorMessages.accountErrors.addGoogleSignin[error.response.status]}`
				}
		 	
		 		this.setState({submitLoading:false,errorMessage:errorMessage})
			})
	}



	render() {
		const {googleUser,meta}=this.props
		const {errorMessage,submitLoading}=this.state
		let method='remove'
		let formSubmit=this.removeGoogle
		if(googleUser){
			method='add'
			formSubmit=this.addGoogle
		}

		
		const isbeConnected = (meta && meta.isbeOptedInAt)

		return (
			 <div className={'accountAuthentication ' + (method ? `is--${method}` : '')}>     
				

				{method==='add' &&

					<div className='accountAuthentication-selectedGoogleAccountCard'>
						Selected Google Account
						<div className='accountAuthentication-selectedGoogleAccountCard-card'>
							<div className='accountAuthentication-selectedGoogleAccountCard-card-avatar'>
								<img src={googleUser.profileObj.imageUrl} alt=''/>
							</div>
							<div className='accountAuthentication-selectedGoogleAccountCard-card-details'>
								<div className='accountAuthentication-selectedGoogleAccountCard-card-details-name'>
									{googleUser.profileObj.name}
								</div>
								<div className='accountAuthentication-selectedGoogleAccountCard-card-details-email'>
									{googleUser.profileObj.email}
								</div>
							</div>            
						</div>
					</div>
				}

				

				{method==='remove' &&
					<div className='accountAuthentication-confirmText'>
						<b>Please provide your Plickers password to remove Google Sign-in.</b>
					</div> 
				}

				{method==='remove' && isbeConnected &&
					<div className='accountAuthentication-confirmText accountAuthentication-confirmText--warning'>
						If you remove your Google Sign-in, you will lose access to your Ed360 integration.<br/> You will lose access to any pre-rostered Classes and associated student responses, and  access to all Plickers Pro features.
					</div>
				}


				{method !=='add' &&			
					<VerifyWithPasswordForm
						onSubmit={formSubmit}
						method={method}
						submitLoading={submitLoading}
					/>
				}

				{method==='remove' && 
					<div className='accountAuthentication-signOutEverywhere'>
						<FeatureModalSelectControl
							checkbox
							checked={this.state.logOut}
							onClick={()=>(this.setState({logOut:!this.state.logOut}))}
							label='Require all devices to sign in again'
						/>		
					</div>
				}  

			

				{method ==='add' &&		
    				<Button 
    					onClickFunction={this.addGoogle}
    					submitLoading={submitLoading}
    					size='large'
    					label={'Confirm'}
    					color={'blue'}
    					type='submit'>
    				</Button>	        		
				}





				{method==='add' && !errorMessage &&
					<div className='accountAuthentication-confirmBtnExplainer'>
							After confirming, you will be able to sign in with both your Google account and your existing email address and password.
					</div>
				}

				{method==='remove' && !errorMessage &&
					<div className='accountAuthentication-confirmBtnExplainer'>
							After removing Google Sign-in, you will be only be able to sign in with the existing email address and password associated with your Plickers account.
					</div>
				}  

				{errorMessage &&
					<div className='accountAuthentication-error'>
						{errorMessage}
					</div>
				}

			</div>
		)
	}
}
 


export default connect(
	(state,ownProps) => ({
		user:state.user,
		googleUser:state.modals.googleUser,
		setBanner:state.modals.setBanner,
		meta:state.meta
	}),
	{addGoogleSignin,
		hideModal,
		removeGoogleSignin,
		showNotification}
)(AccountAuthenticationContainer)